/**
 * Main file for Custom ACF Block js.
 */

import './featured-resources';
import './promotional-content';
import './role';
